import { useQuery } from '@tanstack/react-query'

import type { FeedbackStatus } from './management/types'
import { useFeedbackApi } from './feedback-api'

export interface MyFeedbackSummary {
  reference: string
  id: string
  text: string
  seitentitel: string
  modulId: string | null
  angelegtAm: string
  status: FeedbackStatus
  letzteAntwortAm: string | null
  unreadMessages: number
}

export interface MyFeedbackPage {
  items: MyFeedbackSummary[]
  total: number
  unreadCount: number
}

export interface MyFeedbackActivity {
  id: string
  art:
    'Kommentar' | 'Statusänderung' | 'Umsetzung' | 'Bereichsänderung' | 'Zurückstellung'
  angelegtAm: string
  autorName: string
  text: string | null
  vorherigerStatus: FeedbackStatus | null
  neuerStatus: FeedbackStatus | null
}

export interface MyFeedbackDetail {
  feedback: MyFeedbackSummary
  activities: MyFeedbackActivity[]
}

const myFeedbackKey = ['feedback', 'meine'] as const

export function useMyFeedback(pageSize = 2, page = 1) {
  const api = useFeedbackApi()
  return useQuery({
    queryKey: [...myFeedbackKey, pageSize, page],
    queryFn: ({ signal }) =>
      api.get<MyFeedbackPage>('/eintraege/meine', {
        query: { pageSize, page },
        signal,
      }),
    refetchInterval: 30_000,
  })
}

export function useMyFeedbackDetail(id: string | undefined) {
  const api = useFeedbackApi()
  return useQuery({
    queryKey: [...myFeedbackKey, 'detail', id ?? ''],
    enabled: Boolean(id),
    queryFn: ({ signal }) =>
      api.get<MyFeedbackDetail>(`/eintraege/meine/${id}`, { signal }),
    refetchInterval: 30_000,
  })
}
